<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';
import ListaTrilhaDeAcolhimento from './components/ListaTrilhaDeAcolhimento.vue';


const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();

const showTrilhaDeAcolhimento = ref(false)
const name = ref('')

onMounted(() => {
  felixBagAuxStore.pauseAfter(6000)
  checkName()
});

function finalizarAcolhimento() {
  felixBagAuxStore.seekTo(felixBagAuxStore.scenes.avaliacao_final_acolhimento)
}

function openTrilhaDeAcolhimento() {
  showTrilhaDeAcolhimento.value = true
}

function checkName() {
  if (window.ovmConfig.env['NOME_SOCIAL']) {
    name.value = window.ovmConfig.env['NOME_SOCIAL'].split(" ")[0]
  } else if (window.ovmConfig.env['NOME_CADASTRADO']) {
    name.value = window.ovmConfig.env['NOME_CADASTRADO'].split(" ")[0]
  } else {
    name.value = window.ovmConfig.env['PRIMEIRO_NOME']
  }
}


</script>

<template>
  <div id="trilha-de-acolhimento">
    <v-row align-content="center" justify="space-evenly"
      style="margin-top: 22%;margin-bottom: 10%; padding: 0 3% 0 7.5%;" class="top-area">
      <v-avatar style="border: 1px solid #FF9900;" color="white">
        <img :src="globalStateStore.globalState.selectedData.profile.img" style="width: 100%;" alt="">
      </v-avatar>
      <div style="text-align: start; width: 47%;">
        <p style="color: #464646; font-size: 11px;">Estamos com você</p>
        <p style="font-size: 18px; margin-right: 20px;">{{ name }}</p>
      </div>

      <div style="width: 40px; height: 40px;">
        <button
          style="background-color:rgb(102, 0, 153); width: 100%; height: 100%; border-radius: 8px; align-items: center; display: flex; justify-content: center;"
          @click="felixBagAuxStore.showInteractive('dicas-de-uso')">
          <img style="width: 65%;"
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/d520f86a-9e4e-4455-bc4b-195600a42048.svg"
            alt="">
        </button>
      </div>
    </v-row>

    <div class="menu-item" @click="openTrilhaDeAcolhimento">
      <v-row>
        <v-col cols="6">
          <img
            src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/250edb9e-a7e0-4a6b-bc90-01dbce5df767.svg"
            alt="">
        </v-col>

        <v-col cols="6" class="item-text">
          <v-chip style="background: #81D300; color: white; font-size: 10px;" density="compact">{{
            globalStateStore.calcularPorcentagemAcolhimento() }}% completo</v-chip>
          <p class="item-title">Trilha de Acolhimento</p>
        </v-col>
      </v-row>
    </div>

    <v-btn v-if="!globalStateStore.globalState.selectedData.doneAvaliacao" @click="finalizarAcolhimento"
      style="width: 80%; position: absolute; bottom: 15%; left: 10%" class="text-none" color="#660099">Finalizar trilha
      de
      Acolhimento</v-btn>
  </div>

  <ListaTrilhaDeAcolhimento @close-list="showTrilhaDeAcolhimento = false" v-if="showTrilhaDeAcolhimento" />
</template>

<style scoped>
#trilha-de-acolhimento {
  width: 100%;
  height: 100%;
}

.top-area {
  margin-top: 10%;
}

.menu-item {
  background-color: #fff;
  width: 85%;
  height: 23%;
  border-radius: 8px;
  margin: 10% 7.5% 11%;
  cursor: pointer;
}

.menu-item img {
  width: 85%;
  margin: 10px 20px;
}

.item-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: flex-start;
}

.item-title {
  margin-top: 7px;
  width: 70%;
}
</style>
